// extracted by mini-css-extract-plugin
export var resizer = "_fx-0";